import { GET_SR_CATEGORIES_SUCCESS } from '../actionConstants';

import { arrayToObject } from './utils';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_SR_CATEGORIES_SUCCESS: {
      const data = (action.res && action.res.data) || [];
      return {
        ...state,
        categories: arrayToObject(data),
        pmcId: action.PMCId,
      };
    }
    default:
      return state;
  }
};
